import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type QuestionsTemplate from 'modules/surveys/store/models/QuestionsTemplate'

import BasicInfo from './BasicInfo'
import QuestionsContent from './QuestionsContent'

interface Props {
  questionsTemplate: QuestionsTemplate
}

const MainContent = ({ questionsTemplate }: Props) => {
  return (
    <Box gap="s48">
      <BasicInfo questionsTemplate={questionsTemplate} />
      <QuestionsContent questionsTemplate={questionsTemplate} />
    </Box>
  )
}

export default observer(MainContent)
